/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useEffect, useState } from 'react';

import { makeStyles } from '@material-ui/core/styles';

import UARangePicker from '../UARangePicker';
import { customEndAdornmentMultiRangePicker, customHeaderMultiRangePicker } from './utils';

const useStyles = makeStyles((theme) => ({
    datepickerCustomHeader: {
        paddingLeft: '1rem',
        paddingRight: '1rem',
        paddingTop: '1rem',
        borderBottom: '1px solid rgba(224, 224, 224, 1)',
        paddingBottom: '10px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textInput: {
        height: '2rem',
        width: '12rem',
        '& .MuiSelect-select': {
            borderRadius: '4px',
        },
        '& .MuiSelect-selectMenu svg': {
            display: 'none',
        },
        '@media (max-width:600px)': {
            width: '9.5rem',
        },
    },
    valueWithChip: {
        display: 'flex',
        alignItems: 'center',
        height: '100%',
    },
    chip: {
        color: '#455A64',
        backgroundColor: '#F1F2F5',
        height: '18px',
        width: '24px',
        display: 'flex',
        justifyContent: 'center',
        marginLeft: '1rem',
        boxShadow: 'none',
        '& .MuiChip-label': {
            padding: 0,
        },
    },
    doubleCarretIcon: {
        marginRight: '0.7rem',
    },
    clearButton: {
        backgroundColor: theme.palette.text.mainBlue,
        color: theme.palette.text.primary,
        height: '2rem',
        border: 'none',
        margin: 'unset',
        borderRadius: '3px',
        '&:hover': {
            backgroundColor: theme.palette.text.mainBlue,
        },
    },
    selectedDate: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& svg': {
            paddingLeft: '10px',
        },
    },
    dateOption: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
}));

const UAMultiRangePicker = ({ dropdownOptions = [], onUpdateRanges, id, className, ranges = [], onClose }) => {
    const classes = useStyles();
    const [dateType, setDateType] = useState(dropdownOptions && dropdownOptions[0]);

    const [selectedRange, setSelectedRange] = useState(null);

    const handleDropdownChange = (value) => {
        const dateTypeLabel = dropdownOptions.find((option) => option.key === value);
        const existingRange = (ranges || []).find((dt) => dt.dateType === value);
        if (!existingRange) {
            const now = new Date();
            const newSelectedRange = { startDate: now, endDate: now };
            onUpdateRanges([...ranges, { dateType: value, dateTypeLabel: !!dateTypeLabel && dateTypeLabel.label, ...newSelectedRange }]);
            setSelectedRange(newSelectedRange);
        } else {
            setSelectedRange(existingRange);
        }
        setDateType(value);
    };

    const handleUpdateRanges = (updatedRange) => {
        const dateRangeIdx = ranges.findIndex((dr) => dr.dateType === dateType);
        const updatedDateRanges = [...ranges];
        updatedDateRanges[dateRangeIdx] = { ...updatedDateRanges[dateRangeIdx], ...updatedRange };
        onUpdateRanges(updatedDateRanges);
    };

    const onCloseCalendar = (event) => {
        onClose(event);
    };

    const clearSelectedDate = () => {
        //remove dateType from selected dates object
        const newRanges = ranges.filter((range) => range.dateType && range.dateType !== dateType);

        // select the first selected Date if exists
        if (!!newRanges.length) {
            onUpdateRanges(newRanges);
            setDateType(newRanges[0].dateType);
        } else {
            onUpdateRanges([{ dateType: '', dateTypeLabel: '' }]);
            const now = new Date();
            const newSelectedRange = { startDate: now, endDate: now };
            setSelectedRange(newSelectedRange);
            setDateType('');
        }
    };

    useEffect(() => {
        if (!ranges) {
            if (dropdownOptions.length === 1) {
                onUpdateRanges([{ dateType: dropdownOptions[0].key, dateTypeLabel: dropdownOptions[0].label }]);
            } else {
                onUpdateRanges([{ dateType: '', dateTypeLabel: '' }]);
            }
        } else if (ranges.length === 1 && !(ranges[0].startDate || ranges[0].endDate)) {
            if (dropdownOptions.length === 1 && !ranges[0].dateType) {
                onUpdateRanges([{ dateType: dropdownOptions[0].key, dateTypeLabel: dropdownOptions[0].label }]);
            }
            const now = new Date();
            setSelectedRange({ startDate: now, endDate: now });
            setDateType(ranges[0].dateType);
        } else {
            const type = typeof dateType === 'object' ? dateType.key : dateType;
            const selectedDateRange = ranges.find((dr) => dr.dateType === type);
            if (selectedDateRange) {
                const { _dateType, ...restRange } = selectedDateRange;
                setSelectedRange(restRange);
            }
        }
    }, [ranges, dateType, onUpdateRanges]);

    const customHeader = customHeaderMultiRangePicker({
        classes,
        handleDropdownChange,
        dateType,
        dropdownOptions,
        ranges,
        clearSelectedDate,
    });

    const customEndAdornment = customEndAdornmentMultiRangePicker({ ranges, classes });

    return (
        <div className={`${className}`}>
            <UARangePicker
                id={id}
                customHeader={customHeader}
                customInputEndAdornment={customEndAdornment}
                onUpdateRanges={handleUpdateRanges}
                range={selectedRange}
                onClose={onCloseCalendar}
            />
        </div>
    );
};

export default UAMultiRangePicker;
